import React, { useState } from 'react'
import Header from '../components/header/Header'
import FloatingButton from '../components/bottomtotop/FloatingButton'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa6';
import Footer from '../components/footer/Footer';
import avatar1 from '../../assets/images/avatar-1.png';
import avatar2 from '../../assets/images/avatar-2.png';
import avatar3 from '../../assets/images/avatar-3.png';
import avatar4 from '../../assets/images/avatar-4.png';
import avatar5 from '../../assets/images/avatar-5.png';

const FAQs = () => {
  const faqData = [
      // General
      {
        id: 1,
        category: "General",
        question: "What is a 'Seller'?",
        answer: (
          <>
            Every company or organization that signs up for Selzor to accept orders from their customers (wholesale or otherwise) is a <strong>'Seller'</strong>.
            When you register as a Seller on Selzor, you are automatically enrolled in our Free Plan. All the paid pricing plans are applicable only to Sellers.
          </>
        )
      },
      {
        id: 2,
        category: "General",
        question: "What is a 'Buyer'?",
        answer: (
          <>
            Every company or organization that signs up for Selzor to place orders to their suppliers is called a <strong>'Buyer'</strong>.
            
            This includes your Distributors, Dealers, Wholesalers, and Retailers who place orders with you. Selzor is 100% FREE for Buyers placing orders.
          </>
        )
      },
      {
        id: 3,
        category: "General",
        question: "What is a 'User'?",
        answer: (
          <>
            Selzor has two types of users:
            <ul className="list-disc ml-6 mt-2 space-y-1 text-gray-700">
              <li><strong>Paid Users</strong>: Users who manage a Seller account (e.g. Admins, Managers, Sales Reps, Distributors). These are counted in the pricing plans.</li>
              <li><strong>Free Users</strong>: Users who manage a Buyer account (e.g. Group Owners). Each Buyer account includes 5 free users.</li>
            </ul>
          </>
        )
      },
      {
        id: 4,
        category: "General",
        question: "Do I need to sign up for the Selzor Web App and Mobile App separately?",
        answer: (
          <>
            <strong>No.</strong> You only need to sign up once to access your Selzor account. It works seamlessly across both our Web App and Mobile Apps (Android & iOS).
          </>
        )
      },
      {
        id: 5,
        category: "General",
        question: "Do I need to sign up separately as a 'Seller' or 'Buyer'?",
        answer: (
          <>
            <strong>No.</strong> You can use the same credentials to act as both a Seller and a Buyer on Selzor. One signup is enough.
          </>
        )
      },
      {
        id: 6,
        category: "General",
        question: "Can I have multiple Sellers and Buyers in my Selzor account?",
        answer: (
          <>
            Yes, Selzor supports multiple Seller and Buyer accounts using the same login credentials.
            
            <ul className="list-disc ml-6 mt-2 space-y-1 text-gray-700">
              <li>You can add another Seller account only if the current one is on a paid plan.</li>
              <li>You can add up to 3 Buyer accounts with the same login.</li>
              <li>You can also become a User in up to 10 different Seller accounts and 10 Buyer accounts using the same credentials.</li>
            </ul>
          </>
        )
      },
      {
        id: 7,
        category: "General",
        question: "What can I do in the Selzor Free Plan?",
        answer: (
          <>
            Once you sign up as a Seller on Selzor, you're automatically enrolled in our Free Plan. It includes:
            <ul className="list-disc ml-6 mt-2 space-y-1 text-gray-700">
              <li>1 Seller account</li>
              <li>1 User</li>
              <li>25 orders per month</li>
              <li>5 Buyer accounts</li>
              <li>1000 SKUs (product codes)</li>
              <li>5 Custom Order Fields</li>
            </ul>
            <br />
            If you hit the 25-order monthly limit, you won’t receive new orders until the next month begins. This limit resets every 30 days from your Seller signup date.
          </>
        )
      },
      {
        id: 8,
        category: "General",
        question: "Is there any expiry limit for the Free Plan?",
        answer: (
          <>
            No, the Free Plan currently has no expiry limit. You can continue using it indefinitely. If we introduce limitations in the future, you'll be notified in advance.
          </>
        )
      },
      {
        id: 9,
        category: "General",
        question: "What are Custom Order Fields?",
        answer: (
          <>
            Custom Order Fields allow Sellers to add personalized input fields for their buyers during the ordering process, helping collect specific details relevant to their products or business workflow.
          </>
        )
      },
      {
        id: 10,
        category: "General",
        question: "What is a Custom App Code?",
        answer: (
          <>
            When you register as a Seller, Selzor assigns you a unique 8-digit numeric App Code. Buyers use this to connect with you and send orders.
            
            On our Business and Business Plus plans, you can replace this numeric App Code with a branded one that matches your company name.
          </>
        )
      },

    // Billing & Payments
    {
      id: 6,
      category: "Billing & Payments",
      question: "Do I need to make any payment upfront?",
      answer: "No. You can sign up for Selzor and create a 'Seller' or 'Buyer', for accepting or placing orders respectively. You do not have to make any payment. Selzor is 100% FREE for placing orders. When you sign up for a 'Seller' account, you are automatically allotted our Free Plan and can use it for as long as you wish."
    },
    {
      id: 7,
      category: "Billing & Payments",
      question: "What payment methods are available?",
      answer: (
          <>
            Indian Users are redirected to Paytm to make payment. Payment options supported by Paytm include Credit Cards, Debit Cards, Net Banking & Wallets.
            International users are redirected to PayPal to make payment. Payment options supported by PayPal include Credit Cards & PayPal Account.
          </>
        )
    },
  ];

  const categories = ["All", "General", "Billing & Payments"];
  const [activeTab, setActiveTab] = useState("All");
  const [openFaq, setOpenFaq] = useState(faqData[0].id);

  const filteredFaqs =
    activeTab === "All"
      ? faqData
      : faqData.filter((faq) => faq.category === activeTab);

  const toggleFaq = (id) => {
    setOpenFaq((prevId) => (prevId === id ? null : id));
  };

  return (
    <div>
      <Header />
      <section>
        <div className="bg-white p-6 md:p-12 text-black">
          <div className="max-w-7xl mx-auto">
            <div className="flex justify-between">
              <div className="text-start mb-10">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
                  Frequently Asked Questions
                </h2>
                <p className="text-gray-600 text-base sm:text-lg">
                  Answers to common queries about Selzor.
                </p>
              </div>
              <div>
                <button className="bg-[#1a9588] text-white font-semibold px-6 py-3 rounded-full hover:shadow-xl hover:bg-[#28b5a6] transition">
                  Get in Touch
                </button>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap gap-3 mb-8">
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`px-4 py-2 rounded-full border border-gray-300 transition outline-none ${
                    activeTab === cat
                      ? "bg-gray-100 text-gray-600"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                  }`}
                  onClick={() => {
                    setActiveTab(cat);
                    setOpenFaq(null);
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* FAQs */}
            <div className="space-y-4">
              {filteredFaqs.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-[#dbf4f1] rounded-xl px-6 py-5 cursor-pointer transition"
                  onClick={() => toggleFaq(faq.id)}
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-base sm:text-lg text-start md:text-xl font-medium">
                      {faq.question}
                    </h3>
                    <span>
                      {openFaq === faq.id ? <FaAngleUp /> : <FaAngleDown />}
                    </span>
                  </div>
                  {openFaq === faq.id && (
                    <p className="text-gray-700 text-start text-sm sm:text-base lg:text-lg md:text-lg mt-5">
                      {faq.answer}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-12 gap-6">
            {}
            <div className="sm:col-span-8 lg:col-span-9">
              <div className="bg-[#dbf4f1] relative rounded-3xl p-6 sm:p-8 lg:p-16 overflow-hidden">
                {}
                <div className="flex flex-col gap-10">
                  <div className="flex items-center gap-2">
                    <span className="border border-gray-300 px-4 py-1.5 rounded-full text-sm text-gray-600">
                      Join the Community
                    </span>
                    <span className="border-t-2 w-[63px] border-gray-300"></span>
                  </div>

                  <div className='text-start'>
                    <h2 className="text-3xl sm:text-4xl lg:text-4xl font-semibold text-gray-700 mb-2 sm:mb-3">Connect with us on Selzor</h2>
                    <p className="text-gray-700 text-lg max-w-md mt-2">
                      Get support, share insights, and grow together.
                    </p>
                  </div>
                </div>

                {}
                <div className=" text-start mt-10 flex flex-col gap-2 max-w-md">
                  <div className='w-auto'>
                    <button className="bg-[#1a9588] text-white font-semibold text-sm px-6 py-3 rounded-full hover:shadow-xl hover:bg-[#28b5a6] transition">
                      Join Selzor Community
                    </button>
                  </div>
                  <p className="text-sm text-gray-500">
                    Have questions? Our community is here to help. Learn more about{" "}
                    <a href="/" className="text-blue-800 underline">
                      our community
                    </a>
                    .
                  </p>
                </div>

                {}
                <div className="hidden lg:block absolute -right-40 bottom-[-160px] opacity-10 text-blue-600">
                  <svg className="w-[430px] h-[466px]" viewBox="0 0 430 466" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill="currentColor"
                      opacity="0.08"
                      d="M338.865 7.65501C384.41 -17.229 438.326 22.2206 428.453 73.206L362.518 413.718C362.061 416.788 361.368 419.837 360.436 422.839C358.377 429.849 355.397 435.688 351.689 440.393C351.581 440.543 351.473 440.692 351.364 440.841C331.376 468.207 293.007 474.172 265.666 454.167C252.106 444.245 243.805 429.799 241.32 414.419L241.333 414.428C233.747 385.894 244.587 309.302 301.474 186.701L323.393 211.292L352.417 92.773C353.72 87.4517 347.934 83.2176 343.263 86.0748L239.233 149.712L270.533 164.061C211.517 226.313 129.346 284.552 71.0875 290.69C56.5339 292.223 39.1151 288.401 25.5612 278.484C-1.78032 258.478 -7.74121 220.077 12.2472 192.712C12.2987 192.641 12.3504 192.571 12.4021 192.501C12.4609 192.421 12.5198 192.341 12.5788 192.262C15.9306 187.304 20.5806 182.694 26.6222 178.607C29.2021 176.803 31.9007 175.213 34.6905 173.844L338.865 7.65501Z"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {}
            <div className="sm:col-span-4 lg:col-span-3 flex flex-col gap-6">
              {}
              <div className="bg-[#dbf4f1] rounded-3xl text-center py-8 px-6">
                <h2 className="text-3xl sm:text-4xl lg:text-6xl font-semibold text-gray-700 mb-2 sm:mb-3">
                  8<span className="text-4xl text-gray-500">k+</span>
                </h2>
                <p className="text-gray-600 text-lg mt-2">Trusted by professionals worldwide</p>
              </div>

              {}
              <div className="flex justify-center">
                <svg className="w-[70px] md:w-[122px]" viewBox="0 0 122 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    opacity="0.4"
                    d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
                    stroke="currentColor"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              {}
              <div className="bg-[#dbf4f1] rounded-3xl text-center py-8 px-6">
                <div className="flex justify-center -space-x-4 mb-3"> 
                  {[avatar1, avatar2, avatar3, avatar4, avatar5].map((avatar, index) => (
                    <img
                      key={index}
                      src={avatar}
                      alt={`Avatar ${index + 1}`}
                      className="w-10 h-10 sm:w-14 sm:h-14 rounded-full border-2 border-white"
                      style={{ zIndex: 50 - index }}
                    />
                  ))}
                </div>
                <p className="text-sm text-gray-700 font-semibold">10k+ Reviews (4.5 out of 5)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FloatingButton />
      <Footer />
    </div>
  );
};

export default FAQs;
